import config from '@config';
import { FILE_KEY } from '@api/constants';
import { getJwtToken } from '@utils/auth';

export const configureFocus = ({ editor }) => {
  // TODO: check if event listener should be removed when editor unmounts
  editor.on('focus', () => {
    editor.dom.addClass(editor.iframeElement, 'focused');
  });
  editor.on('blur', () => {
    editor.dom.removeClass(editor.iframeElement, 'focused');
  });
};

export const imagesUploadHandler = async (blobInfo, success, failure, progress) => {
  const xhr = new XMLHttpRequest();
  xhr.withCredentials = false;
  xhr.open('POST', `${config.api.url}/api/v1/images`);

  try {
    const jwtToken = await getJwtToken();
    xhr.setRequestHeader('Authorization', `Bearer ${jwtToken}`);
  } catch (e) {
    failure(e.message);
  }

  xhr.upload.onprogress = (e) => {
    progress((e.loaded / e.total) * 100);
  };

  xhr.onload = () => {
    if (xhr.status < 200 || xhr.status >= 300) {
      failure(`HTTP Error: ${xhr.status}`);
      return;
    }

    if (typeof xhr.responseText !== 'string') {
      failure(`Invalid response: ${xhr.responseText}`);
      return;
    }

    success(`${config.media.url}/${xhr.responseText}`);
  };

  xhr.onerror = () => {
    failure(`Image upload failed due to a XHR Transport error. Code: ${xhr.status}`);
  };

  const formData = new FormData();
  formData.append(FILE_KEY, blobInfo.blob(), blobInfo.filename());

  xhr.send(formData);
};
